export default "__VITE_ASSET__0cUga0KK__"